import React from "react";
import { StyleSheet, View } from "react-native";
import { Colors } from "../../../theme/colors";

export function PageDots({ total, index }: { total: number; index: number }) {
  return (
    <View style={styles.row}>
      {Array.from({ length: total }).map((_, i) => (
        <View key={i} style={[styles.dot, i === index ? styles.active : styles.inactive]} />
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  row: { flexDirection: "row", justifyContent: "center", gap: 8 },
  dot: { height: 8, borderRadius: 999 },
  active: { width: 28, backgroundColor: Colors.orange400 },
  inactive: { width: 8, backgroundColor: Colors.white50 },
});
